// extracted by mini-css-extract-plugin
module.exports = {"confirmMailContainer":"ConfirmMail_confirmMailContainer__3lqf4","redirectLink":"ConfirmMail_redirectLink__1957H"};